import React, { useState } from 'react';

import { Popover } from 'antd';

import { showDateNoTime } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import InAgencySinceDrawer from '../ModelDetails/Drawer/InAgencySinceDrawer';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactDetailsInAgencySince = ({ contact, iconSize, readOnly }) => {
    const [drawer, setDrawer] = useState(false);

    const userids = contact && contact.users ? contact.Users.map((user) => user.UserID) : [];
    const viewModelAnagraphical = useUserPermission('ViewModelAnagraphical', userids);

    const inAgencySince =
        contact.NetworkAgencies && contact.NetworkAgencies[0] && contact.NetworkAgencies[0].InAgencyFrom
            ? contact.NetworkAgencies[0].InAgencyFrom
            : null;
    const inAgencySinceString = inAgencySince ? showDateNoTime(inAgencySince, true) : 'n.d.';

    const renderContactDetailsInAgencySince = () => {
        return (
            <Popover
                mouseEnterDelay={0.6}
                content={
                    <p>
                        In the Agency since
                        <br />
                        <strong>{inAgencySinceString}</strong>
                    </p>
                }
            >
                <NwIcon size={iconSize} icon={byPrefixAndName.fasl['play']} />
                &nbsp;&nbsp;
                {inAgencySinceString}
            </Popover>
        );
    };

    return (
        <>
            <div
                className="header-body-boxes header-body-boxes-hoverable"
                onClick={() => viewModelAnagraphical && !readOnly && setDrawer(true)}
            >
                <PermissionBlock permission={viewModelAnagraphical} content={renderContactDetailsInAgencySince()} />
            </div>
            {drawer && (
                <InAgencySinceDrawer
                    contact={contact}
                    onClose={() => {
                        setDrawer(false);
                    }}
                />
            )}
        </>
    );
};

export default ContactDetailsInAgencySince;
